import { throttle } from 'lodash-es'
import { useEffect, useMemo, useRef } from 'react'

export const useThrottledCallback = (
    f: (...args: any) => void,
    delay: number,
) => {
    const callbackRef = useRef(f)

    useEffect(() => {
        callbackRef.current = f
    }, [f])

    const throttledCallback = useMemo(
        () =>
            throttle((...args: any[]) => {
                callbackRef.current(...args)
            }, delay),
        [delay],
    )

    useEffect(() => {
        return () => {
            throttledCallback.cancel()
        }
    }, [throttledCallback])

    return throttledCallback
}
